<template>
    <DsModal
        class="publish-success-modal"
        is-open
        size="md"
        dialog
        show-close
        @close="$emit('close')"
    >
        <div class="publish-success-modal-content">
            <DsIllustration name="success-confetti-color" />

            <span
                data-qa="success"
                class="success"
            >
                {{ $t('funnel.edit.publish.success') }}
            </span>

            <span
                data-qa="success-message"
                class="success-message"
            >
                {{ $t('funnel.edit.publish.success.message') }}
            </span>

            <div class="button-row">
                <DsFilledButton
                    data-qa="continue-editing"
                    @click="$emit('close')"
                >
                    {{ $t('funnel.edit.publish.success.continue.editing') }}
                </DsFilledButton>

                <DsTextButton
                    data-qa="view-automations"
                    @click="viewAutomations"
                >
                    {{ $t('funnel.edit.publish.success.view.automations') }}
                </DsTextButton>
            </div>
        </div>
    </DsModal>
</template>
<script>
export default {
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['close', 'view-automations'],
    methods: {
        viewAutomations() {
            this.$emit('view-automations');
        },
    },
};
</script>
<style lang="scss" scoped>
.publish-success-modal {
    --modal-header-border: none;
    --modal-padding: 0;
    --modal-width: #{px-to-rem(410)};
}
.publish-success-modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 0 $spacing-200;
}
.success {
    font-family: $font-family-secondary-title;
    font-size: $font-size-xl;
    font-weight: $font-weight-bold;
    text-align: center;
    margin-bottom: 1.75rem;
    margin-top: $spacing-200;
}
.success-message {
    font-size: $font-size-lg;
    margin-bottom: 1.75rem;
}
.button-container {
    display: flex;
    grid-gap: $spacing-200;
    margin-top: $spacing-300;
}
</style>
